<template>
  <a-tabs
    v-model:activeKey="active"
    type="card"
    :tabBarGutter="10"
    :destroyInactiveTabPane="destroyInactiveTabPane"
    class="x-card-tab"
    :class="{ 'h-full': hasFull }"
  >
    <a-tab-pane
      v-for="tab in dictList"
      :key="tab.key"
      :tab="tab.label"
      :class="`x-tab-${tab.key}`"
    >
      <slot :name="tab.key" />
    </a-tab-pane>
    <template v-if="$slots.rightExtra" #rightExtra>
      <slot name="rightExtra" />
    </template>
  </a-tabs>
</template>
<script lang="ts" name="XCardTab" setup>
const props = withDefaults(
  defineProps<{
    modelValue?: string | number
    name: string
    destroyInactiveTabPane?: boolean
  }>(),
  {}
)
const emit = defineEmits(['update:modelValue', 'change', 'tabScrollBottom'])
const solts = useSlots()
const dictList = computed(() => useDicts(props.name))

const active = computed({
  get: () => props.modelValue,
  set: (v) => {
    emit('update:modelValue', v)
    emit('change', v)
  },
})

const hasFull = computed(() => {
  return Object.keys(solts).includes(String(active.value))
})
</script>

<style scoped>
.x-card-tab {
  display: flex;
  flex-direction: column;

  :deep(.ant-tabs-tab) {
    background: var(--back-2);
    color: var(--text-1-80);
    line-height: 32px;
    padding: 2px 24px;
    border: 1px solid transparent;
    &:hover {
      color: var(--text-1);
      font-weight: bold;
    }
    &.ant-tabs-tab-active {
      background: var(--tab-active-bg);
      font-weight: bold;

      border: 1px solid rgba(5, 5, 5, 0.06);
      .ant-tabs-tab-btn {
        color: var(--text-1) !important;
      }
    }
  }
  :deep(.ant-tabs-content-holder) {
    overflow: auto;
  }
}
</style>
